import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faWandMagicSparkles,
} from "@fortawesome/free-solid-svg-icons";

const images = [
  "/img/design1.png",
  "/img/design2.png",
  "/img/design8.png",
  "/img/design5.png",
  "/img/design3.png",
  "/img/design7.png",
  "/img/design4.png",
  "/img/design6.png",
  "/img/design0.png",
];

const getVisibleCount = () => {
  if (window.innerWidth < 640) return 3;
  if (window.innerWidth < 1024) return 5;
  return 7;
};

const getGapSize = () => {
  if (window.innerWidth < 640) return 120; // მცირე ზომის მობილურებისთვის
  if (window.innerWidth < 1024) return 130; // პლანშეტებისთვის
  return 150; // დიდი ეკრანებისთვის (Desktop)
};

const CustomQr = () => {
  const [visibleCount, setVisibleCount] = useState(getVisibleCount());
  const [offset, setOffset] = useState(0);
  const [index, setIndex] = useState(0);

  const animationRef = useRef();

  const { t } = useTranslation();

  const [gap, setGap] = useState(getGapSize());

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleCount());
      setGap(getGapSize()); // აქაც ვანახლებთ ზომას
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 🔥 TRUE CONTINUOUS ANIMATION (premium feel)
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const getItems = () => {
    const half = Math.floor(visibleCount / 2);
    const items = [];

    // ვიღებთ იმაზე მეტ ელემენტს, რომ "წრეზე" ტრიალისას ცარიელი ადგილი არ გამოჩნდეს
    for (let i = -half - 2; i <= half + 2; i++) {
      // ეს ფორმულა პოულობს სწორ სურათს მასივიდან წრიულად
      const imgIndex =
        (((index + i) % images.length) + images.length) % images.length;
      items.push({
        src: images[imgIndex],
        pos: i,
        id: `${imgIndex}-${index + i}`, // უნიკალური ID თითოეული პოზიციისთვის
      });
    }

    return items;
  };

  const items = getItems();

  return (
    <div className="custom-tag-by-own-design-container">
      <div className="custom-tag-by-own-design-title-container">
        <p>{t("custom tag section title 1")}</p>
        <h3>{t("custom tag section title 2")}</h3>
      </div>

      <div className="custom-tag-by-own-design">
        <hr />
        {getItems().map((item) => {
          // x პოზიცია ყოველთვის ფიქსირებულია ეკრანზე, რადგან index-ს ვიყენებთ სურათის შესარჩევად
          const x = item.pos * gap;
          const distance = Math.abs(item.pos);

          const scale = 1 - Math.min(distance * 0.2, 0.5);
          const opacity = 1 - Math.min(distance * 0.3, 0.7);

          return (
            <img
              key={item.id}
              src={item.src}
              alt="pet"
              style={{
                transform: `translateX(${x}px) scale(${scale})`,
                opacity,
                zIndex: 100 - Math.round(distance * 10),
              }}
            />
          );
        })}
      </div>

      <Link to="/order/qrcollar">
        {t("create")} <FontAwesomeIcon icon={faWandMagicSparkles} />
      </Link>
    </div>
  );
};

export default CustomQr;
